import { render, staticRenderFns } from "./AuthenticatedParent.vue?vue&type=template&id=cae3e184"
import script from "./AuthenticatedParent.vue?vue&type=script&lang=ts"
export * from "./AuthenticatedParent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports